import { render } from "./SupportContactPage.vue?vue&type=template&id=8ee47c42"
import script from "./SupportContactPage.vue?vue&type=script&lang=js"
export * from "./SupportContactPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__